module.exports = __webpack_public_path__ + "static/media/bio-background.c442e57d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bio-background.png
// module id = 105
// module chunks = 0